// ── 上市公司高管交易信号 — SEC EDGAR Form 4 ─────────────────────────────
// PrimaryLens 覆盖的绝大多数项目是未上市的早期 Web3 项目，没有股票 ticker/CIK，
// 这个信号只对少数已上市的项目（比如 Circle/CRCL）适用。TICKER_MAP 是手动维护的
// 项目名 → ticker/CIK 映射（不是自动发现——大部分项目压根不该匹配到任何东西）。
// 实际的 Form 4 拉取 + XML 解析在 proxy/server.js 的 /api/insider-activity（见
// proxy/form4.js），因为原始 XML 所在的 www.sec.gov/Archives 不支持浏览器 CORS，
// 前端不能直接拉。

const TICKER_MAP = {
  circle: { ticker: 'CRCL', cik: '0001876042', companyName: 'Circle Internet Group, Inc.' },
  'circle internet': { ticker: 'CRCL', cik: '0001876042', companyName: 'Circle Internet Group, Inc.' },
  'circle internet group': { ticker: 'CRCL', cik: '0001876042', companyName: 'Circle Internet Group, Inc.' },
};

/**
 * 项目名能否解析到一个已上市公司的 ticker/CIK——解析不到就是 null，调用方应该
 * 直接不渲染这张卡片，而不是展示一个空状态（大部分项目本来就不适用）。
 * @param {string} projectName
 * @returns {{ ticker: string, cik: string, companyName: string } | null}
 */
export function resolveTicker(projectName) {
  const key = (projectName || '').toLowerCase().trim();
  return TICKER_MAP[key] || null;
}

/**
 * @param {string} cik - 10 位数字 CIK（比如 '0001876042'）
 * @param {string} [apiBase] - proxy base URL
 * @returns {Promise<{ companyName, ticker, cik, transactions: object[], eightKDates: string[] } | null>}
 */
export async function fetchInsiderActivity(cik, apiBase = '') {
  if (!cik) return null;
  try {
    const res = await fetch(`${apiBase}/api/insider-activity?cik=${encodeURIComponent(cik)}`);
    if (!res.ok) return null;
    const json = await res.json();
    if (!json.ok) return null;
    return json.data;
  } catch {
    return null;
  }
}
